module.exports = __webpack_public_path__ + "media/images/flags/zm-4ce0e8e2df519f1b8be56891ec493756.svg";